import { render, staticRenderFns } from "./AdminGalleryConfig.vue?vue&type=template&id=dcfbca1a&"
import script from "./AdminGalleryConfig.vue?vue&type=script&lang=js&"
export * from "./AdminGalleryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports